var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.RmpText,{staticClass:"mb-4",attrs:{"font":"secondary","type":"body-medium-bold","color":_setup.colors.grey.darken1}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }